// extracted by mini-css-extract-plugin
module.exports = {"cancel":"RequestDetail_cancel__c68EO"};